import { NotificationArea } from './NotificationArea';
import { LinkedList } from './LinkedList';
import { TopMenu } from './TopMenu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import VolumeDownIcon from '@mui/icons-material/VolumeDown';
import { PATHS } from 'commons/paths';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import LoadingModal from 'organisms/LoadingModal';
import { A03Output } from 'api/U003';

type MobileProps = {
  isSp: boolean;
  notifications: {
    notice_id: number;
    start_dtm: Date;
    notice_title: string;
    notice: string;
    file1: string | undefined;
    file2: string | undefined;
    file3: string | undefined;
    file4: string | undefined;
    file5: string | undefined;
  }[];
  loadingOnNotifications: boolean;
  errOnNotifications: Error | null;
  news: {
    news_id: number;
    start_dtm: Date;
    news_title: string;
    news: string;
    file1: string;
    file2: string;
    file3: string;
    file4: string;
    file5: string;
  }[];
  loadingOnFetchNews: boolean;
  errOnFetchNews: Error | null;
  auditions: A03Output;
  loadingOnFetchAuditions: boolean;
  errOnFetchAuditions: Error | null;
};
export const Mobile: React.FC<MobileProps> = (props) => {
  const { t: tMypage } = useTranslationWithLang('mypage');
  const { t: tMessage } = useTranslationWithLang('message');
  return (
    <>
      {(props.loadingOnFetchNews ||
        props.loadingOnNotifications ||
        props.loadingOnFetchAuditions) && <LoadingModal />}
      <div className="max-w-[1000px] m-auto">
        <div className="m-auto">
          <TopMenu isSp={props.isSp} />
          <div className="m-4">
            <NotificationArea
              title={tMypage('TU003_001')}
              icon={<NotificationsIcon className="text-white" />}
              data={props.notifications.map((n) => {
                return {
                  id: n.notice_id,
                  title: n.notice_title,
                  published_at: n.start_dtm,
                  notice: n.notice,
                  file1: n.file1 ?? undefined,
                  file2: n.file2 ?? undefined,
                  file3: n.file3 ?? undefined,
                  file4: n.file4 ?? undefined,
                  file5: n.file5 ?? undefined,
                };
              })}
              err={props.errOnNotifications ? tMessage('MU003F0035E') : null}
              loading={props.loadingOnNotifications}
              expanded={false}
              noItemsMsg={tMessage('MU003F0038E')}
              buttonLabel={tMypage('TU003_002')}
              isSp={props.isSp}
            />
            <div className="my-8">
              <NotificationArea
                title={tMypage('TU003_004')}
                icon={<VolumeDownIcon className="text-white" />}
                data={props.news.map((n) => {
                  return {
                    id: n.news_id,
                    title: n.news_title,
                    published_at: n.start_dtm,
                    notice: n.news,
                    file1: n.file1,
                    file2: n.file2,
                    file3: n.file3,
                    file4: n.file4,
                    file5: n.file5,
                  };
                })}
                err={props.errOnFetchNews ? tMessage('MU003F0035E') : null}
                loading={props.loadingOnFetchNews}
                expanded={false}
                noItemsMsg={tMessage('MU003F0036E')}
                buttonLabel={tMypage('TU003_005')}
                isSp={props.isSp}
              />
            </div>
            <LinkedList
              title={tMypage('TU003_003')}
              icon={''}
              items={props.auditions.auditions.map((v) => {
                return {
                  key: `${v.id}`,
                  title: v.title,
                  link: `${PATHS.AUDITION_INFO}/${v.id}`,
                };
              })}
              err={props.errOnFetchAuditions ? tMessage('MU003F0035E') : null}
              loading={props.loadingOnFetchAuditions}
              noItemMsg={tMessage('MU003F0037E')}
            />
          </div>
        </div>
      </div>
    </>
  );
};
